module.exports = __webpack_public_path__ + "img/48-shuziku.f9d2ec3c.png";